import { graphql } from '@/gql/generated'

export const getLatestPmpsMetadataQueryDocument = graphql(/* GraphQL */ `
  query getLatestPmpMetadata($token: String!, $key: String!) {
    pmps_metadata(where: { token: { _ilike: $token }, key: { _eq: $key } }, order_by: { created_at: desc }, limit: 1) {
      id
      key
      token
      token_pmp_nonce
      created_at
    }
  }
`)
